<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="8" :sm="24">
              <a-form-item label="排序" prop="sendTime">
               <a-select v-model="queryParam.type" placeholder="请选择">
<!--                 <a-select-option :key="1">观看广告数由大到小</a-select-option>-->
                 <a-select-option :key="2">解锁总数由大到小</a-select-option>
<!--                 <a-select-option :key="3">充值总金额由大到小</a-select-option>-->
                 <a-select-option :key="4">观看数由大到小</a-select-option>
               </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="昵称" prop="nickname">-->
<!--                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="短剧名称" prop="videoId">
                <!--                <a-input v-model="queryParam.videoId" placeholder="请输入短剧id" allow-clear/>-->
                <a-tree-select
                  v-model="queryParam.videoId"
                  show-search
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  placeholder="请选择短剧"
                  allow-clear
                  tree-default-expand-all
                  showSearch
                  treeNodeFilterProp="title"
                >
                  <a-tree-select-node :value="item.id" :key="item.id" :title="item.videoName" v-for="(item,index) in listAll">
                  </a-tree-select-node>
                </a-tree-select>
              </a-form-item>
            </a-col>

<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="剧集" prop="serialNumber">-->
<!--                <a-input-number :min="1" v-model="queryParam.serialNumber" style="width: 100%;" placeholder="请输入" allow-clear />-->
<!--              </a-form-item>-->
<!--            </a-col>-->

            <a-col :md="8" :sm="24">
              <a-form-item label="时间" prop="sendTime">
                <a-range-picker v-model="sendTimeAreaData" @change="onChangeTime" style="width: 100%">
                </a-range-picker>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="剧集id" prop="gatherId">-->
<!--                  <a-input v-model="queryParam.gatherId" placeholder="请输入剧集id" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="花費金額" prop="price">-->
<!--                  <a-input v-model="queryParam.price" placeholder="请输入花費金額" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:buy/video:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:buy/video:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:buy/video:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:buy/video:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="videoId"
        :columns="columns"
        :data-source="list"

        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" />-->
<!--          <a @click="$refs.adForm.handleQuery(record,queryParam.startTime,queryParam.endTime)">-->
<!--            <a-icon type="eye" />观看广告记录-->
<!--          </a>-->

          <a-divider type="vertical" />
          <a @click="$refs.videoForm.handleQuery(record, queryParam.startTime,queryParam.endTime)">
            <a-icon type="eye" />解锁记录
          </a>

<!--          <a-divider type="vertical" />-->
<!--          <a @click="$refs.rechargeForm.handleQuery(record, queryParam.startTime,queryParam.endTime)">-->
<!--            <a-icon type="eye" />充值记录-->
<!--          </a>-->
          <a-divider type="vertical" />
          <a @click="$refs.watchForm.handleQuery(record,queryParam.startTime,queryParam.endTime)">
            <a-icon type="eye" />观看记录
          </a>

<!--          <a-divider type="vertical" v-hasPermi="['user:buy/video:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['user:buy/video:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
      <WatchForm ref="watchForm" />
      <VideoForm ref="videoForm" />
      <AdForm ref="adForm" />
      <RechargeForm ref="rechargeForm" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageBuyVideo,statisticsPage, listBuyVideo, delBuyVideo, pageBuyVideoVideoPage} from '@/api/shortVideo/buyVideo'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listVideo } from '@/api/shortVideo/video/video'
import VideoForm  from "./modules/VideoForm";
import WatchForm from './modules/WatchForm'
import AdForm from './modules/AdForm'
import RechargeForm from './modules/RechargeForm'
export default {
  name: 'BuyVideo',
  components: {
    CreateForm,
    VideoForm,
    WatchForm,
    AdForm,
    RechargeForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      sendTimeAreaData:[],
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        videoId: null,
        gatherId: null,
        type: undefined,
        price: null,
        startTime:"",
        endTime:"",
        pageNum: 1,
        pageSize: 10
      },
      listAll:[],

      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '序号',
          // ellipsis: true,,
          customRender: (text, record, index) => index + 1,
          width: '10%',
          align: 'center'
        },
        // {
        //   title: '用户昵称',
        //   dataIndex: 'nickname',
        //   width: '20%',
        //   align: 'center'
        // },
        {
          title: '短剧名称',
          dataIndex: 'videoName',
          width: '20%',
          align: 'center'
        },
        // {
        //   title: '剧集',
        //   dataIndex: 'serialNumber',
        //   width: '10%',
        //   align: 'center'
        // },
        {
          title: '解锁类型',
          dataIndex: 'videoType',
          width: '10%',
          align: 'center',
          customRender: function (t, r, index) {
            if(t == 0) {
              return '免费'
            }else if(t == 1) {
              return '必捷斯'
            }else if(t == 2) {
              return '钻石'
            }else if(t == 3) {
              return '会员'
            }
          }
        },
        // {
        //   title: '观看广告数',
        //   dataIndex: 'adNum',
        //   width: '10%',
        //   align: 'center'
        // },

        {
          title: '解锁总数',
          dataIndex: 'totalPrice',
          width: '10%',
          align: 'center'
        },

        // {
        //   title: '充值总金额',
        //   dataIndex: 'totalRechargePrice',
        //   width: '10%',
        //   align: 'center'
        // },

        {
          title: '观看数',
          dataIndex: 'totalLookNum',
          width: '10%',
          align: 'center'
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   width: '30%',
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getGather();

  },
  computed: {
  },
  watch: {
  },
  methods: {
    onChangeTime(e,str) {
      this.queryParam.startTime = str[0];
      this.queryParam.endTime = str[1];
    },
    getGather() {
      listVideo().then(res => {
        this.listAll = res.data;
      })
    },
    /** 查询用户购买剧集记录清单 */
    getList () {
      this.loading = true
      statisticsPage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        videoId: undefined,
        gatherId: undefined,
        type: undefined,
        price: undefined,
        startTime:"",
        endTime:"",
        pageNum: 1,
        pageSize: 10
      }
      this.sendTimeAreaData = [];
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delBuyVideo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids清单
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user-buy-video/export', {
            ...that.queryParam
          }, `用户购买剧集记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
